webpackJsonp([22],{

/***/ 1542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduledReports_vue__ = __webpack_require__(1908);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "context", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduledReports_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e4f4189_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduledReports_vue__ = __webpack_require__(2396);
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduledReports_vue__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e4f4189_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduledReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1550);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1560);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1561) });


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(955);
var gOPS = __webpack_require__(1558);
var pIE = __webpack_require__(1555);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(959);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(442)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1564), __esModule: true };

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(957);
__webpack_require__(1565);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(221);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(965);
var isArrayIter = __webpack_require__(966);
var toLength = __webpack_require__(445);
var createProperty = __webpack_require__(1566);
var getIterFn = __webpack_require__(963);

$export($export.S + $export.F * !__webpack_require__(967)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(1544);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        title: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        alternativeDeleteText: {
            type: String,
            required: false,
            default: 'AreYouSureDelete'
        }
    },
    watch: {},
    methods: {
        confirm: function confirm() {
            this.$emit('confirm');
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    },
    computed: {},
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_0__components_Button__["a" /* default */]
    },
    mounted: function mounted() {},
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 1577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__ = __webpack_require__(1568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__ = __webpack_require__(1587);
function injectStyle (ssrContext) {
  __webpack_require__(1585)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-905c32ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1585:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1586);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("727af110", content, true, {});

/***/ }),

/***/ 1586:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DeleteConfirm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-5 pr-5"},[_c('p',{staticClass:"mb-0 pt-4",staticStyle:{"text-align":"center","font-weight":"600","font-size":"18px"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.alternativeDeleteText)))]),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4"},[_c('div',{staticClass:"col flex-grow pr-2"},[_c('Button',{attrs:{"title":_vm.$t('Cancel'),"buttonClass":"cancel-button semi-bold w-100"},on:{"onClick":_vm.cancel}})],1),_vm._v(" "),_c('div',{staticClass:"col flex-grow pl-2"},[_c('Button',{attrs:{"title":_vm.$t('Delete'),"buttonClass":"delete-button semi-bold w-100"},on:{"onClick":_vm.confirm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DeleteConfirm_vue__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ScheduledReports_ScheduledReportModal_vue__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ScheduledReports_ReportListCell_vue__ = __webpack_require__(2392);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var context = null;

// Musi odpowiadac ReportFrequencyEnum i SupportedLanguageEnum na backendzie.
var FREQUENCY_LABELS = ['Daily', 'Weekly', 'Monthly'];
var LANGUAGE_LABELS = ['English', 'Norwegian'];
var WEEK_DAY_LABELS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

/* harmony default export */ __webpack_exports__["b"] = ({
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["k" /* Search */]]
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal_vue__["a" /* default */],
        DeleteConfirm: __WEBPACK_IMPORTED_MODULE_7__components_DeleteConfirm_vue__["a" /* default */],
        ScheduledReportModal: __WEBPACK_IMPORTED_MODULE_8__components_ScheduledReports_ScheduledReportModal_vue__["a" /* default */]
    },
    data: function data() {
        return {
            reports: [],
            activeModal: 'NONE',
            activeReport: null,
            actionText: '',

            pageSettings: { pageSize: 50, pageSizes: [10, 25, 50, 100] },
            toolbar: [{ text: this.$t('ScheduledReports'), align: 'Left', id: 'table-title' }, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('AddScheduledReport'), prefixIcon: 'e-add', id: 'add-scheduled-report', align: 'Right' }, 'Search'],
            wrapSettings: { wrapMode: 'Header' },
            filterOptions: { type: 'Menu' },
            filterCheckBox: { type: 'CheckBox' },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm', type: 'dateTime' },
            customAttributes: { class: 'customcss' },
            recipientsTemplate: function recipientsTemplate() {
                return {
                    template: {
                        extends: __WEBPACK_IMPORTED_MODULE_9__components_ScheduledReports_ReportListCell_vue__["a" /* default */],
                        propsData: { listField: 'recipientsList' }
                    }
                };
            },
            scopeTemplate: function scopeTemplate() {
                return {
                    template: {
                        extends: __WEBPACK_IMPORTED_MODULE_9__components_ScheduledReports_ReportListCell_vue__["a" /* default */],
                        propsData: { listField: 'scopeList' }
                    }
                };
            },
            optionsTemplate: function optionsTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('optionsTemplate', {
                        template: '\n                            <div class="horizontal grow">\n                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick(\'EDIT\')" content="' + context.$t('Edit') + '" v-tippy="{ theme : \'customTheme\', placement : \'left\', arrow : true }">\n                                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z" stroke="#346F8B" stroke-width="1.3"/></svg>\n                                </div>\n                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick(\'DELETE\')" content="' + context.$t('Delete') + '" v-tippy="{ theme : \'customTheme\', placement : \'left\', arrow : true }">\n                                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>\n                                </div>\n                            </div>\n                        ',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            onClick: function onClick(mode) {
                                switch (mode) {
                                    case 'EDIT':
                                        context.openModal(this.data, 'EDIT');
                                        break;
                                    case 'DELETE':
                                        context.openDeleteModal(this.data);
                                        break;
                                }
                            }
                        }
                    })
                };
            }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.dispatch('set_loading', true);
                                _context.prev = 1;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api__["_48" /* getScheduledReports */])();

                            case 4:
                                result = _context.sent;

                                _this.reports = result.map(function (report) {
                                    var recipients = _this.listRecipients(report);
                                    var scopes = _this.listScope(report);

                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, report, {
                                        frequencyName: _this.$t(FREQUENCY_LABELS[report.frequency] || '-'),
                                        languageName: LANGUAGE_LABELS[report.language] || '-',
                                        scheduleName: _this.formatSchedule(report),
                                        recipientsList: recipients,
                                        // Pelny tekst zostaje w polu kolumny, zeby sortowanie, filtrowanie i wyszukiwanie widzialy wszystkie pozycje.
                                        recipientsName: recipients.join(', '),
                                        scopeList: scopes,
                                        scopeName: scopes.join(', '),
                                        activeName: report.isActive ? _this.$t('Yes') : _this.$t('No'),
                                        lastSentAt: report.lastSentAt ? new Date(report.lastSentAt) : null,
                                        nextRunAt: report.nextRunAt ? new Date(report.nextRunAt) : null
                                    });
                                });

                            case 6:
                                _context.prev = 6;

                                _this.$store.dispatch('set_loading', false);
                                return _context.finish(6);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1,, 6, 9]]);
            }))();
        },
        pad: function pad(value) {
            return value < 10 ? '0' + value : '' + value;
        },
        formatSchedule: function formatSchedule(report) {
            var time = this.pad(report.sendHour) + ':' + this.pad(report.sendMinute);
            var suffix = report.skipWeekends ? ' (' + this.$t('WithoutWeekends') + ')' : '';

            if (report.frequency === 1 && report.dayOfWeek) {
                return this.$t(WEEK_DAY_LABELS[report.dayOfWeek - 1]) + ', ' + time + suffix;
            }

            if (report.frequency === 2 && report.dayOfMonth) {
                return this.$t('DayOfMonth') + ' ' + report.dayOfMonth + ', ' + time + suffix;
            }

            return '' + time + suffix;
        },
        listRecipients: function listRecipients(report) {
            var recipients = report.recipients || [];
            return recipients.map(function (x) {
                return x.name || x.userEmail || x.email;
            }).filter(function (x) {
                return x;
            });
        },
        listScope: function listScope(report) {
            var _this2 = this;

            var scopes = report.scopes || [];
            var systems = scopes.filter(function (x) {
                return x.systemId;
            }).map(function (x) {
                return x.systemName;
            }).filter(function (x) {
                return x;
            });
            var groups = scopes.filter(function (x) {
                return x.systemGroupId;
            }).map(function (x) {
                return x.systemGroupName + ' (' + _this2.$t('Group') + ')';
            }).filter(function (x) {
                return x;
            });

            return systems.concat(groups);
        },

        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case 'add-scheduled-report':
                    this.openModal(null, 'ADD');
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        openModal: function openModal(item, mode) {
            this.activeReport = item;
            this.activeModal = mode;
        },
        openDeleteModal: function openDeleteModal(item) {
            this.activeReport = item;
            this.actionText = this.$t('DeleteScheduledReport') + ': ' + item.name;
            this.activeModal = 'DELETE';
        },
        closeModal: function closeModal(mode) {
            this.activeReport = null;
            this.actionText = '';
            this.activeModal = 'NONE';

            if (mode === 'getData') {
                this.getData();
            }
        },
        deleteReportConfirm: function deleteReportConfirm() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api__["z" /* deleteScheduledReport */])(_this3.activeReport.id);

                            case 2:
                                _this3.closeModal('getData');

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            context = this;

                            _context3.next = 3;
                            return this.getData();

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button_vue__ = __webpack_require__(1544);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Musi odpowiadac ReportFrequencyEnum na backendzie.
var FREQUENCY_DAILY = 0;
var FREQUENCY_WEEKLY = 1;
var FREQUENCY_MONTHLY = 2;

// Backend ogranicza dzien miesiaca do 28, zeby raport wyszedl takze w lutym.
var MAX_DAY_OF_MONTH = 28;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Button: __WEBPACK_IMPORTED_MODULE_5__Button_vue__["a" /* default */] },
    props: {
        // Istniejaca konfiguracja do edycji, albo null przy dodawaniu nowej.
        current: {
            type: Object,
            default: null
        }
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */]]
    },
    data: function data() {
        return {
            report: {
                id: null,
                name: '',
                isActive: true,
                frequency: FREQUENCY_DAILY,
                sendHour: 5,
                sendMinute: 0,
                dayOfWeek: 1,
                dayOfMonth: 1,
                skipWeekends: false,
                language: 0
            },
            users: [],
            systems: [],
            groups: [],
            selectedUsers: [],
            selectedSystems: [],
            selectedGroups: [],
            // Zaznaczenia do odtworzenia przy edycji. null = juz odtworzone (albo nie ma czego).
            pendingUserIds: null,
            pendingSystemIds: null,
            pendingGroupIds: null,
            externalEmails: [],
            externalEmailInput: '',
            error: '',
            message: '',

            hours: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()({ length: 24 }, function (item, index) {
                return index;
            }),
            minutes: [0, 15, 30, 45],
            monthDays: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()({ length: MAX_DAY_OF_MONTH }, function (item, index) {
                return index + 1;
            }),
            weekDays: [{ value: 1, label: 'Monday' }, { value: 2, label: 'Tuesday' }, { value: 3, label: 'Wednesday' }, { value: 4, label: 'Thursday' }, { value: 5, label: 'Friday' }, { value: 6, label: 'Saturday' }, { value: 7, label: 'Sunday' }],

            wrapSettings: { wrapMode: 'Content' },
            selectionOptions: { type: 'Multiple', checkboxOnly: true, persistSelection: false },
            filterOptions: { type: 'Menu' },
            filterCheckbox: { type: 'CheckBox' }
        };
    },

    computed: {
        periodHint: function periodHint() {
            if (this.report.frequency === FREQUENCY_WEEKLY) {
                return 'PeriodHintWeekly';
            }

            if (this.report.frequency === FREQUENCY_MONTHLY) {
                return 'PeriodHintMonthly';
            }

            // Przy pomijaniu weekendow raport dzienny obejmuje w poniedzialek takze sobote i niedziele.
            return this.report.skipWeekends ? 'PeriodHintDailySkipWeekends' : 'PeriodHintDaily';
        },

        // Dla cyklu tygodniowego i miesiecznego trzeba osobno powiedziec o przesunieciu terminu -
        // podpowiedz dzienna mowi o tym sama.
        skipWeekendsHint: function skipWeekendsHint() {
            if (!this.report.skipWeekends || this.report.frequency === FREQUENCY_DAILY) {
                return '';
            }

            return 'PeriodHintSkipWeekends';
        }
    },
    methods: {
        pad: function pad(value) {
            return value < 10 ? '0' + value : '' + value;
        },
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_5" /* getAllUsers */])();

                            case 2:
                                _this.users = _context.sent;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_88" /* getSystemsWithCountries */])();

                            case 5:
                                _context.t0 = function (a, b) {
                                    return _this.compareNames(a.systemName, b.systemName);
                                };

                                _this.systems = _context.sent.sort(_context.t0);
                                _context.next = 9;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_27" /* getExistingGroups */])();

                            case 9:
                                _context.t1 = function (a, b) {
                                    return _this.compareNames(a.name, b.name);
                                };

                                _this.groups = _context.sent.sort(_context.t1);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // Sortowanie naturalne jak na liscie systemow (Systems.vue) - "geno 2" przed "geno 11".
        compareNames: function compareNames(a, b) {
            return (a || '').localeCompare(b || '', undefined, { numeric: true, sensitivity: 'base' });
        },
        usersSelectionChanged: function usersSelectionChanged() {
            this.selectedUsers = this.$refs.users_grid.getSelectedRecords();
        },
        systemsSelectionChanged: function systemsSelectionChanged() {
            this.selectedSystems = this.$refs.systems_grid.getSelectedRecords();
        },
        groupsSelectionChanged: function groupsSelectionChanged() {
            this.selectedGroups = this.$refs.groups_grid.getSelectedRecords();
        },
        addExternalEmail: function addExternalEmail() {
            var email = (this.externalEmailInput || '').trim();

            if (email === '') {
                return;
            }

            if (!this.isEmailValid(email)) {
                this.error = this.$t('InvalidEmail');
                return;
            }

            if (this.externalEmails.some(function (x) {
                return x.toLowerCase() === email.toLowerCase();
            })) {
                this.externalEmailInput = '';
                return;
            }

            this.externalEmails.push(email);
            this.externalEmailInput = '';
            this.error = '';
        },
        removeExternalEmail: function removeExternalEmail(email) {
            this.externalEmails = this.externalEmails.filter(function (x) {
                return x !== email;
            });
        },
        isEmailValid: function isEmailValid(email) {
            var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            return re.test(String(email).toLowerCase());
        },
        buildPayload: function buildPayload() {
            var recipients = this.selectedUsers.map(function (x) {
                return { applicationUserId: x.id };
            }).concat(this.externalEmails.map(function (email) {
                return { email: email };
            }));

            var scopes = this.selectedSystems.map(function (x) {
                return { systemId: x.id };
            }).concat(this.selectedGroups.map(function (x) {
                return { systemGroupId: x.id };
            }));

            return {
                id: this.report.id,
                name: this.report.name,
                isActive: this.report.isActive,
                frequency: this.report.frequency,
                sendHour: this.report.sendHour,
                sendMinute: this.report.sendMinute,
                dayOfWeek: this.report.frequency === FREQUENCY_WEEKLY ? this.report.dayOfWeek : null,
                dayOfMonth: this.report.frequency === FREQUENCY_MONTHLY ? this.report.dayOfMonth : null,
                skipWeekends: this.report.skipWeekends,
                language: this.report.language,
                recipients: recipients,
                scopes: scopes
            };
        },
        checkRequirements: function checkRequirements() {
            this.error = '';

            if (!this.report.name || this.report.name.trim() === '') {
                this.error = this.$t('ReportNameRequired');
                return;
            }

            if (this.selectedUsers.length === 0 && this.externalEmails.length === 0) {
                this.error = this.$t('SelectAtLeastOneRecipient');
                return;
            }

            if (this.selectedSystems.length === 0 && this.selectedGroups.length === 0) {
                this.error = this.$t('SelectAtLeastOneSystemOrGroup');
            }
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var payload;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.checkRequirements();

                                if (!(_this2.error !== '')) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 3:
                                payload = _this2.buildPayload();
                                _context2.prev = 4;

                                if (!payload.id) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["N" /* editScheduledReport */])(payload);

                            case 8:
                                _context2.next = 12;
                                break;

                            case 10:
                                _context2.next = 12;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["g" /* addScheduledReport */])(payload);

                            case 12:

                                _this2.$emit('saved');
                                _context2.next = 18;
                                break;

                            case 15:
                                _context2.prev = 15;
                                _context2.t0 = _context2['catch'](4);

                                _this2.error = _this2.readError(_context2.t0);

                            case 18:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[4, 15]]);
            }))();
        },
        preview: function preview() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var html, previewWindow;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_104" /* previewScheduledReport */])(_this3.report.id);

                            case 3:
                                html = _context3.sent;
                                previewWindow = window.open('', '_blank');


                                if (previewWindow) {
                                    previewWindow.document.write(html);
                                    previewWindow.document.close();
                                }
                                _context3.next = 11;
                                break;

                            case 8:
                                _context3.prev = 8;
                                _context3.t0 = _context3['catch'](0);

                                _this3.error = _this3.readError(_context3.t0);

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[0, 8]]);
            }))();
        },
        sendNow: function sendNow() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;
                                _context4.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_114" /* sendScheduledReportNow */])(_this4.report.id);

                            case 3:
                                result = _context4.sent;

                                _this4.error = '';
                                _this4.message = _this4.$t('SentToRecipients') + ': ' + result.sent;
                                _context4.next = 12;
                                break;

                            case 8:
                                _context4.prev = 8;
                                _context4.t0 = _context4['catch'](0);

                                _this4.message = '';
                                _this4.error = _this4.readError(_context4.t0);

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[0, 8]]);
            }))();
        },
        readError: function readError(e) {
            if (e && e.response && e.response.data && e.response.data.error) {
                return e.response.data.error;
            }

            return '' + e;
        },
        restoreUsersSelection: function restoreUsersSelection() {
            this.restoreSelection('users_grid', 'pendingUserIds', 'selectedUsers');
        },
        restoreSystemsSelection: function restoreSystemsSelection() {
            this.restoreSelection('systems_grid', 'pendingSystemIds', 'selectedSystems');
        },
        restoreGroupsSelection: function restoreGroupsSelection() {
            this.restoreSelection('groups_grid', 'pendingGroupIds', 'selectedGroups');
        },

        /**
         * Odtworzenie zaznaczen zapisanego raportu. Wolane z dataBound, a nie zaraz po pobraniu
         * danych - siatka renderuje wiersze asynchronicznie po podmianie dataSource i wczesniej
         * getCurrentViewRecords() zwraca jeszcze pusta liste.
         */
        restoreSelection: function restoreSelection(gridRef, pendingProp, selectedProp) {
            var ids = this[pendingProp];

            if (ids === null) {
                return;
            }

            if (ids.length === 0) {
                this[pendingProp] = null;
                return;
            }

            var grid = this.$refs[gridRef];
            var records = grid ? grid.getCurrentViewRecords() || [] : [];

            // Pierwszy dataBound leci jeszcze na pustej siatce - czekamy na ten z danymi.
            if (records.length === 0) {
                return;
            }

            // Po pierwszym odtworzeniu czyscimy liste, zeby filtrowanie czy sortowanie
            // nie przywracalo pozycji odznaczonych przez uzytkownika.
            this[pendingProp] = null;

            // Zaznaczenia odtwarzamy po id, nie po nazwie - nazwy nie sa unikalne.
            var indexes = records.map(function (record, index) {
                return ids.indexOf(record.id) >= 0 ? index : -1;
            }).filter(function (index) {
                return index >= 0;
            });

            if (indexes.length === 0) {
                return;
            }

            grid.selectRows(indexes);

            // Stan czytamy wprost z siatki, zamiast polegac na zdarzeniu rowSelected.
            this[selectedProp] = grid.getSelectedRecords();
        },
        applyCurrent: function applyCurrent() {
            this.report = {
                id: this.current.id,
                name: this.current.name,
                isActive: this.current.isActive,
                frequency: this.current.frequency,
                sendHour: this.current.sendHour,
                sendMinute: this.current.sendMinute,
                dayOfWeek: this.current.dayOfWeek || 1,
                dayOfMonth: this.current.dayOfMonth || 1,
                skipWeekends: this.current.skipWeekends === true,
                language: this.current.language
            };

            var recipients = this.current.recipients || [];
            var scopes = this.current.scopes || [];

            this.externalEmails = recipients.filter(function (x) {
                return !x.applicationUserId && x.email;
            }).map(function (x) {
                return x.email;
            });

            this.pendingUserIds = recipients.filter(function (x) {
                return x.applicationUserId;
            }).map(function (x) {
                return x.applicationUserId;
            });
            this.pendingSystemIds = scopes.filter(function (x) {
                return x.systemId;
            }).map(function (x) {
                return x.systemId;
            });
            this.pendingGroupIds = scopes.filter(function (x) {
                return x.systemGroupId;
            }).map(function (x) {
                return x.systemGroupId;
            });
        }
    },
    // Synchronicznie, przed pobraniem danych - inaczej dataBound siatki moglby wyprzedzic
    // rozpakowanie edytowanego raportu i zaznaczenia nie zostalyby odtworzone.
    created: function created() {
        if (this.current) {
            this.applyCurrent();
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return _this5.getData();

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
});

/***/ }),

/***/ 1910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

// Ile pozycji pokazujemy w komorce - reszta idzie w licznik i tooltip, zeby wiersz nie rozpychal tabeli.
var VISIBLE_ITEMS = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        // Pole wiersza z tablica pozycji do wyswietlenia (np. recipientsList).
        listField: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            data: {}
        };
    },
    computed: {
        items: function items() {
            return this.data[this.listField] || [];
        },
        visibleItems: function visibleItems() {
            return this.items.slice(0, VISIBLE_ITEMS);
        },
        hiddenCount: function hiddenCount() {
            return Math.max(0, this.items.length - VISIBLE_ITEMS);
        }
    }
});

/***/ }),

/***/ 2388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduledReportModal_vue__ = __webpack_require__(1909);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ec0c85_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduledReportModal_vue__ = __webpack_require__(2391);
function injectStyle (ssrContext) {
  __webpack_require__(2389)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25ec0c85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduledReportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ec0c85_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduledReportModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2389:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2390);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("3eba8bf6", content, true, {});

/***/ }),

/***/ 2390:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "h4[data-v-25ec0c85]{text-align:center;font-size:16px;padding-top:10px}.hint[data-v-25ec0c85]{font-size:11px;color:#6b6b6b;margin-top:10px}.error[data-v-25ec0c85]{color:#fd8282}.error[data-v-25ec0c85],.success[data-v-25ec0c85]{text-align:left!important;font-size:11px;font-weight:700;margin-top:8px}.success[data-v-25ec0c85]{color:#2e7d32}#info-container[data-v-25ec0c85]{width:34%;padding:20px;background:#fff;border:1px solid #efefef;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1);border-radius:5px 0 0 5px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#recipients-container[data-v-25ec0c85],#systems-container[data-v-25ec0c85]{width:33%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.grid-box[data-v-25ec0c85]{height:240px;width:92%;margin:auto;padding:0 0 10px}.gallery-container[data-v-25ec0c85]{background:#f9f9f9;-webkit-box-shadow:0 0 40px rgba(53,110,138,.25);box-shadow:0 0 40px rgba(53,110,138,.25);border-radius:5px}.info-field[data-v-25ec0c85]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px}.info-field-title[data-v-25ec0c85]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-25ec0c85]{width:100%;margin:0;padding-bottom:5px}.info-field-value[data-v-25ec0c85]{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}.chips[data-v-25ec0c85]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;min-height:24px}.chip[data-v-25ec0c85]{background:#e6eef2;color:#34758e;border-radius:12px;padding:2px 10px;font-size:11px;font-weight:600}.chip-remove[data-v-25ec0c85]{cursor:pointer;margin-left:6px;font-weight:700}select[data-v-25ec0c85]{border:none;width:100%}select[data-v-25ec0c85]:focus{outline:none;border-bottom:1px solid #0095b2}option[data-v-25ec0c85]{padding:4px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/ScheduledReports/ScheduledReportModal.vue"],"names":[],"mappings":"AACA,oBACI,kBAAmB,AACnB,eAAgB,AAChB,gBAAkB,CACrB,AACD,uBACI,eAAgB,AAChB,cAAe,AACf,eAAiB,CACpB,AACD,wBAEI,aAAe,CAIlB,AACD,kDANI,0BAA4B,AAE5B,eAAgB,AAChB,gBAAkB,AAClB,cAAgB,CAQnB,AAND,0BAEI,aAAe,CAIlB,AACD,iCACI,UAAW,AACX,aAAc,AAEd,gBAAoB,AACpB,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAAoD,AAC5C,mCAA4C,AACpD,0BAA+B,AAE/B,yBAA0B,AAEtB,sBAAuB,AAEnB,8BAA+B,AACvC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,2EAEI,UAAW,AACX,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,2BACI,aAAc,AACd,UAAW,AACX,YAAa,AACb,gBAAoB,CACvB,AACD,oCACI,mBAAoB,AACpB,iDAA0D,AAClD,yCAAkD,AAC1D,iBAAmB,CACtB,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,eAAiB,CACpB,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,WAAY,AACZ,SAAU,AACV,kBAAoB,CACvB,AACD,mCACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAElB,aAAe,CAClB,AACD,wBACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,QAAS,AACT,eAAiB,CACpB,AACD,uBACI,mBAAoB,AACpB,cAAe,AACf,mBAAoB,AACpB,iBAAkB,AAClB,eAAgB,AAChB,eAAiB,CACpB,AACD,8BACI,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CACpB,AACD,wBACI,YAAa,AACb,UAAY,CACf,AACD,8BACI,aAAc,AACd,+BAAiC,CACpC,AACD,wBACI,WAAa,CAChB","file":"ScheduledReportModal.vue","sourcesContent":["\nh4[data-v-25ec0c85] {\n    text-align: center;\n    font-size: 16px;\n    padding-top: 10px;\n}\n.hint[data-v-25ec0c85] {\n    font-size: 11px;\n    color: #6b6b6b;\n    margin-top: 10px;\n}\n.error[data-v-25ec0c85] {\n    text-align: left !important;\n    color: #FD8282;\n    font-size: 11px;\n    font-weight: bold;\n    margin-top: 8px;\n}\n.success[data-v-25ec0c85] {\n    text-align: left !important;\n    color: #2e7d32;\n    font-size: 11px;\n    font-weight: bold;\n    margin-top: 8px;\n}\n#info-container[data-v-25ec0c85] {\n    width: 34%;\n    padding: 20px;\n\n    background: #FFFFFF;\n    border: 1px solid #EFEFEF;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 5px 0px 0px 5px;\n\n    -webkit-box-pack: justify;\n\n        -ms-flex-pack: justify;\n\n            justify-content: space-between;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n#recipients-container[data-v-25ec0c85],\n#systems-container[data-v-25ec0c85] {\n    width: 33%;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.grid-box[data-v-25ec0c85] {\n    height: 240px;\n    width: 92%;\n    margin: auto;\n    padding: 0 0 10px 0;\n}\n.gallery-container[data-v-25ec0c85] {\n    background: #F9F9F9;\n    -webkit-box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n            box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n    border-radius: 5px;\n}\n.info-field[data-v-25ec0c85] {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n.info-field-title[data-v-25ec0c85] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-25ec0c85] {\n    width: 100%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.info-field-value[data-v-25ec0c85] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n}\n.chips[data-v-25ec0c85] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 6px;\n    min-height: 24px;\n}\n.chip[data-v-25ec0c85] {\n    background: #E6EEF2;\n    color: #34758E;\n    border-radius: 12px;\n    padding: 2px 10px;\n    font-size: 11px;\n    font-weight: 600;\n}\n.chip-remove[data-v-25ec0c85] {\n    cursor: pointer;\n    margin-left: 6px;\n    font-weight: 700;\n}\nselect[data-v-25ec0c85] {\n    border: none;\n    width: 100%;\n}\nselect[data-v-25ec0c85]:focus {\n    outline: none;\n    border-bottom: 1px solid #0095b2;\n}\noption[data-v-25ec0c85] {\n    padding: 4px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal gallery-container"},[_c('div',{attrs:{"id":"info-container"}},[_c('div',[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('ReportName')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.name),expression:"report.name"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},domProps:{"value":(_vm.report.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.report, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Active')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.isActive),expression:"report.isActive"}],staticClass:"crfi-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.report.isActive)?_vm._i(_vm.report.isActive,null)>-1:(_vm.report.isActive)},on:{"change":function($event){var $$a=_vm.report.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.report, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.report, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.report, "isActive", $$c)}}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Frequency')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.frequency),expression:"report.frequency"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.report, "frequency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$t('Daily')))]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t('Weekly')))]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v(_vm._s(_vm.$t('Monthly')))])])])])]),_vm._v(" "),(_vm.report.frequency === 1)?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('DayOfWeek')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.dayOfWeek),expression:"report.dayOfWeek"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.report, "dayOfWeek", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.weekDays),function(day){return _c('option',{key:day.value,domProps:{"value":day.value}},[_vm._v(_vm._s(_vm.$t(day.label)))])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.report.frequency === 2)?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('DayOfMonth')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.dayOfMonth),expression:"report.dayOfMonth"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.report, "dayOfMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.monthDays),function(day){return _c('option',{key:day,domProps:{"value":day}},[_vm._v(_vm._s(day))])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('SkipWeekends')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.skipWeekends),expression:"report.skipWeekends"}],staticClass:"crfi-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.report.skipWeekends)?_vm._i(_vm.report.skipWeekends,null)>-1:(_vm.report.skipWeekends)},on:{"change":function($event){var $$a=_vm.report.skipWeekends,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.report, "skipWeekends", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.report, "skipWeekends", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.report, "skipWeekends", $$c)}}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('SendTime')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('div',{staticClass:"horizontal",staticStyle:{"align-items":"center"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.sendHour),expression:"report.sendHour"}],staticStyle:{"width":"60px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.report, "sendHour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.hours),function(hour){return _c('option',{key:hour,domProps:{"value":hour}},[_vm._v(_vm._s(_vm.pad(hour)))])}),0),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 4px"}},[_vm._v(":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.sendMinute),expression:"report.sendMinute"}],staticStyle:{"width":"60px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.report, "sendMinute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.minutes),function(minute){return _c('option',{key:minute,domProps:{"value":minute}},[_vm._v(_vm._s(_vm.pad(minute)))])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"140px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('ReportLanguage')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.language),expression:"report.language"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.report, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v("English")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Norwegian")])])])])]),_vm._v(" "),_c('p',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t(_vm.periodHint)))]),_vm._v(" "),(_vm.skipWeekendsHint !== '')?_c('p',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t(_vm.skipWeekendsHint)))]):_vm._e(),_vm._v(" "),_c('div',[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.message != '')?_c('div',{staticClass:"success"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"vertical",staticStyle:{"align-self":"center"}},[_c('Button',{staticStyle:{"width":"260px"},attrs:{"title":'Save',"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}}),_vm._v(" "),(_vm.report.id)?_c('Button',{staticStyle:{"width":"260px","margin-top":"8px"},attrs:{"title":'PreviewReport',"buttonClass":"cancel-button semi-bold"},on:{"onClick":_vm.preview}}):_vm._e(),_vm._v(" "),(_vm.report.id)?_c('Button',{staticStyle:{"width":"260px","margin-top":"8px"},attrs:{"title":'SendNow',"buttonClass":"cancel-button semi-bold"},on:{"onClick":_vm.sendNow}}):_vm._e()],1)]),_vm._v(" "),_c('div',{attrs:{"id":"recipients-container"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Recipients')))]),_vm._v(" "),_c('div',{staticClass:"grid-box"},[_c('ejs-grid',{ref:"users_grid",attrs:{"height":"100%","width":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataSource":_vm.users,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"showBusyIndicator":true,"dataBound":_vm.restoreUsersSelection,"rowSelected":_vm.usersSelectionChanged,"rowDeselected":_vm.usersSelectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"fullName","headerText":_vm.$t('Name').toUpperCase(),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"email","headerText":_vm.$t('Email').toUpperCase(),"textAlign":"Left"}})],1)],1)],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('ExternalEmails')))]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"width":"90%","margin":"auto","align-items":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.externalEmailInput),expression:"externalEmailInput"}],staticClass:"datalist-input",staticStyle:{"flex":"1"},attrs:{"type":"email","placeholder":_vm.$t('Email')},domProps:{"value":(_vm.externalEmailInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addExternalEmail.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.externalEmailInput=$event.target.value}}}),_vm._v(" "),_c('Button',{staticStyle:{"margin-left":"8px"},attrs:{"title":'AddEmail',"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.addExternalEmail}})],1),_vm._v(" "),_c('div',{staticClass:"chips",staticStyle:{"width":"90%","margin":"8px auto"}},_vm._l((_vm.externalEmails),function(email){return _c('span',{key:email,staticClass:"chip"},[_vm._v("\n                "+_vm._s(email)+"\n                "),_c('span',{staticClass:"chip-remove",on:{"click":function($event){return _vm.removeExternalEmail(email)}}},[_vm._v("×")])])}),0)]),_vm._v(" "),_c('div',{attrs:{"id":"systems-container"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Systems')))]),_vm._v(" "),_c('div',{staticClass:"grid-box"},[_c('ejs-grid',{ref:"systems_grid",attrs:{"height":"100%","width":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataSource":_vm.systems,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"showBusyIndicator":true,"dataBound":_vm.restoreSystemsSelection,"rowSelected":_vm.systemsSelectionChanged,"rowDeselected":_vm.systemsSelectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"systemName","headerText":_vm.$t('SystemName').toUpperCase(),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"country","headerText":_vm.$t('Country').toUpperCase(),"textAlign":"Left","filter":_vm.filterCheckbox}})],1)],1)],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('Groups')))]),_vm._v(" "),_c('div',{staticClass:"grid-box"},[_c('ejs-grid',{ref:"groups_grid",attrs:{"height":"100%","width":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataSource":_vm.groups,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"showBusyIndicator":true,"dataBound":_vm.restoreGroupsSelection,"rowSelected":_vm.groupsSelectionChanged,"rowDeselected":_vm.groupsSelectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"name","headerText":_vm.$t('Name').toUpperCase(),"textAlign":"Left"}})],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportListCell_vue__ = __webpack_require__(1910);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4360f27e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportListCell_vue__ = __webpack_require__(2395);
function injectStyle (ssrContext) {
  __webpack_require__(2393)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4360f27e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportListCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4360f27e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportListCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2393:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("68ee6a47", content, true, {});

/***/ }),

/***/ 2394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".report-list-more[data-v-4360f27e]{color:#346f8b;font-weight:600;white-space:nowrap}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/ScheduledReports/ReportListCell.vue"],"names":[],"mappings":"AACA,mCACI,cAAe,AACf,gBAAiB,AACjB,kBAAoB,CACvB","file":"ReportListCell.vue","sourcesContent":["\n.report-list-more[data-v-4360f27e] {\n    color: #346F8B;\n    font-weight: 600;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items.length === 0)?_c('span',[_vm._v("-")]):_c('span',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme: 'customTheme', placement: 'bottom', arrow: true, maxWidth: '420px' }),expression:"{ theme: 'customTheme', placement: 'bottom', arrow: true, maxWidth: '420px' }"}],attrs:{"content":_vm.items.join(', ')}},[_vm._v("\n        "+_vm._s(_vm.visibleItems.join(', '))),(_vm.hiddenCount > 0)?_c('span',{staticClass:"report-list-more"},[_vm._v(" +"+_vm._s(_vm.hiddenCount))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":_vm.activeModal === 'ADD',"title":_vm.$t('AddScheduledReport').toUpperCase()},on:{"close":_vm.closeModal}},[_c('scheduled-report-modal',{attrs:{"current":null},on:{"cancel":_vm.closeModal,"saved":function($event){return _vm.closeModal('getData')}}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'EDIT',"title":_vm.$t('EditScheduledReport').toUpperCase()},on:{"close":_vm.closeModal}},[_c('scheduled-report-modal',{attrs:{"current":_vm.activeReport},on:{"cancel":_vm.closeModal,"saved":function($event){return _vm.closeModal('getData')}}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'DELETE',"title":_vm.$t('DeleteScheduledReport').toUpperCase()},on:{"close":_vm.closeModal}},[_c('delete-confirm',{attrs:{"text":_vm.actionText},on:{"cancel":_vm.closeModal,"confirm":_vm.deleteReportConfirm}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"max-grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataSource":_vm.reports,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"name","headerText":_vm.$t('ReportName'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"200px","clipMode":"EllipsisWithTooltip"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"frequencyName","headerText":_vm.$t('Frequency'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterCheckBox,"width":"110px"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"scheduleName","headerText":_vm.$t('SendTime'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"180px","clipMode":"EllipsisWithTooltip"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"recipientsName","headerText":_vm.$t('Recipients'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"210px","template":_vm.recipientsTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"scopeName","headerText":_vm.$t('ReportScope'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"230px","template":_vm.scopeTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"languageName","headerText":_vm.$t('ReportLanguage'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterCheckBox,"width":"120px"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"lastSentAt","headerText":_vm.$t('LastSent'),"textAlign":"Left","type":"date","format":_vm.dateTimeFormatOptions,"customAttributes":_vm.customAttributes,"width":"150px"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"nextRunAt","headerText":_vm.$t('NextRun'),"textAlign":"Left","type":"date","format":_vm.dateTimeFormatOptions,"customAttributes":_vm.customAttributes,"width":"150px"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"activeName","headerText":_vm.$t('Active'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterCheckBox,"width":"100px"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"id","headerText":"","width":"100px","allowSorting":false,"allowFiltering":false,"template":_vm.optionsTemplate}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.c4201fb94f68280687b0.js